import { useMutation } from "@tanstack/react-query";
import { publishSite } from "../../actions/publishSite.actions";

export function usePageBuilderPublishMutation(args: {
    slugName: string;
    draftId: string;
}) {
    const { slugName, draftId } = args;

    return useMutation({
        mutationKey: ["page-builder", "publish"],
        mutationFn: async () => {

            return publishSite({
                draftId,
                slug: slugName,
            });
        },
    });
}
